import React from 'react';
import PropTypes from 'prop-types';
import translations from './translations.js';

function OfferEndingText(props) {
  let offerText;
  const toDate = new Date(props.to);
  const todayMidnight = new Date().setHours(23, 59, 59, 59);
  const tomorrow = new Date().setDate(new Date().getDate() + 1);
  const tomorrowMidnight = new Date(tomorrow).setHours(23, 59, 59, 59);
  const sixDays = new Date().setDate(new Date().getDate() + 6);
  const sixDaysMidnight = new Date(sixDays).setHours(23, 59, 59, 59);

  // if ending today
  if (toDate > new Date().getTime() && toDate <= todayMidnight) {
    offerText = translations.endsToday;
  }
  // if ending tomorrow
  if (toDate > tomorrow && toDate <= tomorrowMidnight) {
    offerText = translations.endsTomorrow;
  }
  // if ending between 2 - 6 days
  if (toDate > tomorrowMidnight && toDate <= sixDaysMidnight) {
    offerText = translations.endsSoon;
  }

  return (
    <span className={'offer-end-text'}>{offerText}</span>
  );
}

OfferEndingText.displayName = 'OfferEndingText';

OfferEndingText.propTypes = {
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
};

export default OfferEndingText;
